import {TYPES as ACC_TYPES} from "../accreditation-action-type.constants";
import {IDS} from "./master-doc-list-action-id.constants";
import {TAB_HIDE, TAB_DISABLE} from '../../../common/tabs/tabs.constants';

const QUERY_PARAMS = '?year&hof&slo&doc';

export const masterDocListTabsState = {
    name: IDS.app_accreditation_scheme_master_doc_list,
    redirectTo: IDS.app_accreditation_scheme_master_doc_list_list,
    url: `/:itemCode/master-doc-list${QUERY_PARAMS}`,
    component: 'tabs'
};

export const masterDocListListState = {
    name: IDS.app_accreditation_scheme_master_doc_list_list,
    url: '/list',
    // component: 'masterDocListList',
    onEnter: $ngRedux => {
        $ngRedux.dispatch({
            type: 'TAB_HIDE',
            id: IDS.app_accreditation_scheme_master_doc_list,
            state: [
                IDS.app_accreditation_scheme_master_doc_list_details
            ]
        });
    }
};
masterDocListListState.onEnter.$inject = ['$ngRedux'];

export const masterDocListDetailState = {
    name: IDS.app_accreditation_scheme_master_doc_list_details,
    url: '/details',
    // component: 'masterDocListDetails',
};



export const masterDocListExportState = {
    name: IDS.app_accreditation_scheme_master_doc_list_export,
    url: '/export',
    // component: 'masterDocListExport',
};